export default class SoundEffect {

  constructor(soundEffectPath) {
    this.soundEffectPath = soundEffectPath
    this.context = null
    this.buffer = ''
    this.source = null
  }

  load () {
    const AudioContext = window.AudioContext || window.webkitAudioContext
    this.context = new AudioContext()
    window.fetch(this.soundEffectPath)
      .then(response => response.arrayBuffer())
      .then(arrayBuffer => this.buffer = arrayBuffer)
  }

  play () {
    if (this.context != null){ this.context.close() }
    const AudioContext = window.AudioContext || window.webkitAudioContext
    this.context = new AudioContext()
    window.fetch(this.soundEffectPath)
      .then(response => response.arrayBuffer())
      .then(arrayBuffer => this.context.decodeAudioData(arrayBuffer))
      .then(audioBuffer => {
        const source = this.context.createBufferSource()
        source.buffer = audioBuffer
        source.connect(this.context.destination)
        source.start()
    })
  }
}
